import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {WorkCom} from '../message/WorkCom';
import {WorkComCriteria} from './WorkComCriteria';

export class WorkComWrapper extends BaseWrapper<WorkCom, WorkComCriteria, BasicScenario>  {}

